<div class="organization-page-container">
  <p
    *ngIf="isOrganizationMember"
    class="organization-page-container__member-welcome-message"
    [innerHTML]="'LABELS.ORGANIZATION_MEMBER_WELCOME_MESSAGE' | translate"
  ></p>
  <organization-details-card
    *ngIf="!!organization"
    [organization]="organization"
    [currentUser]="currentUser"
    [organizationMembers]="organizationMembers"
  />
  <organization-companies-attached-card
    *ngIf="!!organization && !!organizationMembers && isOrganizationAdmin"
    [organization]="organization"
    [organizationMembers]="organizationMembers"
  ></organization-companies-attached-card>
  <organization-members-card
    *ngIf="!!currentUser && !!organizationMembers && !!organizationInvitedMembers"
    [organization]="organization"
    [currentUser]="currentUser"
    [organizationMembers]="organizationMembers"
    [organizationInvitedMembers]="organizationInvitedMembers"
    (deleteOrganizationMember)="onDeleteOrganizationMember($event)"
    (deleteOrganizationMemberInvite)="onDeleteOrganizationMemberInvite($event)"
    (inviteOrganizationMember)="onInviteOrganizationMember($event)"
    (resendOrganizationMemberInvite)="onResendOrganizationMemberInvite($event)"
    (updateOrganizationMember)="onUpdateOrganizationMember($event)"
  ></organization-members-card>
  <organization-payment-and-billing-card
    *ngIf="!!organization && !!organizationSubscriptions && isOrganizationAdmin"
    [organization]="organization"
    [organizationMembers]="organizationMembers"
    [organizationSubscriptions]="organizationSubscriptions"
    [isPayPalPaymentTokenLoading]="isPayPalPaymentTokenLoading"
    [selectedSubscription]="selectedSubscription"
    [isLoadingPaymentMethods]="isLoadingPaymentMethods"
    [allPaymentMethods]="allPaymentMethods"
    [paymentMethods]="paymentMethods"
    [monthlyBillList]="monthlyBillList"
    (resetSelectedSubscription)="onResetSelectedSubscription()"
    (deletePayment)="onRemoveMonthlyPayment($event)"
    (paypalPaymentToken)="onPaypalPaymentToken()"
    (updatePaymentType)="onUpdatePaymentType($event)"
    (stripePaymentToken)="onStripePaymentToken()"
    (payMonthlyBill)="onPayMonthlyBill($event)"
    (updateSubscription)="onUpdateSubscription($event)"
    (removeSubscription)="onRemoveSubscription()"
  ></organization-payment-and-billing-card>
</div>
